import ColorsParam from "./components/ColorsParam";
import DropDownParam from "./components/DropDownParam";
import TextParam from "./components/TextParam";
import AdminTextParam from "./components/admin/AdminTextParam";
import AdminColorsParam from "./components/admin/AdminColorsParam";
import AdminDropDownParam from "./components/admin/AdminDropDownParam";
import SizeParam from "./components/SizeParam";
import AdminSizeParam from "./components/admin/AdminSizeParam";
import FileParam from "./components/FileParam";
import AdminFileParam from "./components/admin/AdminFileParam";

class ParamTypes {
    static get TEXT() {
        return 'text';
    }

    static get COLORS() {
        return 'colors';
    }

    static get DROP_DOWN() {
        return 'drop_down';
    }

    static get SIZE() {
        return 'size';
    }

    static get FILE() {
        return 'file';
    }

    static GET_BY_TEXT(value) {
        switch (value) {
            case 'colors':
                return ParamTypes.COLORS
            case 'drop_down':
                return ParamTypes.DROP_DOWN
            case 'size':
                return ParamTypes.SIZE
            case 'file':
                return ParamTypes.FILE
            default:
                return ParamTypes.TEXT
        }
    }

    static getPriceModifier(param, value, price) {
        switch (ParamTypes.GET_BY_TEXT(param.type)) {
            case 'size':
                return price + (value.width - (param.props?.defaultValue || 20)) * (param.props?.priceChange || 1);
            case 'file':
                if (value.width && value.ratio) {
                    return value.width * value.width * value.ratio * price;
                }

                return price;
            default:
                return price;
        }
    }

    /**
     * @param {ProductParamContract} param
     * @param {function} paramChange
     * @param {Object} value
     * @returns {JSX.Element}
     */
    static GET_COMPONENT(param, paramChange, value, inCart) {
        switch (ParamTypes.GET_BY_TEXT(param.type)) {
            case 'colors':
                return <ColorsParam id={param.key} values={param.values} onChange={paramChange}
                                    value={value || param.values[0]} inCart={inCart} props={param.props}/>
            case 'drop_down':
                return <DropDownParam id={param.key} values={param.values} onChange={paramChange}
                                      value={value || param.values[0]} inCart={inCart} props={param.props}/>
            case 'size':
                return <SizeParam id={param.key} values={param.values} onChange={paramChange}
                                  value={value || param.values[0]} inCart={inCart} props={param.props}/>
            case 'file':
                return <FileParam id={param.key} values={param.values} onChange={paramChange}
                                  value={value || param.values[0]} inCart={inCart} props={param.props}/>
            default:
                return <TextParam id={param.key} values={param.values} onChange={paramChange}
                                  value={value || param.values[0]} inCart={inCart} props={param.props}/>
        }
    }

    /**
     * @param {ProductParamContract} param
     * @param {Object} props
     * @returns {JSX.Element}
     */
    static GET_ADMIN_COMPONENT(param, props) {
        switch (ParamTypes.GET_BY_TEXT(param.type)) {
            case 'colors':
                return <AdminColorsParam param={param} {...props}/>
            case 'drop_down':
                return <AdminDropDownParam param={param} {...props}/>
            case 'file':
                return <AdminFileParam param={param} {...props}/>
            case 'size':
                return <AdminSizeParam param={param} {...props}/>
            default:
                return <AdminTextParam param={param} {...props}/>
        }
    }

    /**
     * @param {ProductParamContract} param
     * @param {Object} value
     * @returns {JSX.Element}
     */
    static GET_COMPONENT_FOR_CART(param, value) {
        switch (ParamTypes.GET_BY_TEXT(param.type)) {
            case 'colors':
                return <ColorsParam id={param.key} values={param.values} value={value || param.values[0]}
                                    forCart={true} props={param.props}/>
            case 'drop_down':
                return <DropDownParam id={param.key} values={param.values} value={value || param.values[0]}
                                      forCart={true} props={param.props}/>
            case 'size':
                return <SizeParam id={param.key} values={param.values} value={value || param.values[0]}
                                  forCart={true} props={param.props}/>
            case 'file':
                return <FileParam id={param.key} values={param.values} value={value || param.values[0]}
                                  forCart={true} props={param.props}/>
            default:
                return <TextParam id={param.key} values={param.values} value={value || param.values[0]} forCart={true}
                                  props={param.props}/>
        }
    }
}

export default ParamTypes;
